module.exports = __webpack_public_path__ + "media/Loops 90 Pad.85f322b3.wav";